import { toast } from 'react-toastify';

/**
 * A READ-ONLY role preview (Authorization-Plan §13.7; previews have full
 * access by default since the owner decision of 2026-10-07, read only only
 * when the identity service's PREVIEW_READ_ONLY is set): the identity
 * service, the gateway and the services answer every write of the previewer
 * with 403 `preview_read_only` (identity: `message`, gateway / libraries:
 * `reason`). Save buttons may stay visible; the refusal is shown as
 * "Preview is read only".
 *
 * No React and no ApiProvider import here (roleChange.ts uses it).
 */
export const PREVIEW_READ_ONLY = 'preview_read_only';
export const PREVIEW_READ_ONLY_MESSAGE = 'Preview is read only';

export const isPreviewReadOnlyPayload = (payload: unknown): boolean => {
  if (!payload || typeof payload !== 'object') return false;
  const p = payload as Record<string, unknown>;
  return p.reason === PREVIEW_READ_ONLY || p.message === PREVIEW_READ_ONLY;
};

/** At most one toast per this many ms (a page may fire several writes at once). */
export const PREVIEW_TOAST_INTERVAL_MS = 3000;

let lastToastAt = 0;

/** Shows "Preview is read only" (throttled). */
export function notifyPreviewReadOnly(now: number = Date.now()): boolean {
  if (now - lastToastAt < PREVIEW_TOAST_INTERVAL_MS) return false;
  lastToastAt = now;
  toast.warning(PREVIEW_READ_ONLY_MESSAGE, {
    position: 'top-right',
    autoClose: 4000,
    theme: 'colored',
    toastId: PREVIEW_READ_ONLY,
  });
  return true;
}

/** Test helper. */
export const resetPreviewToastForTests = (): void => {
  lastToastAt = 0;
};
